export const COUNTY_DATA = {
    "CL": {
        "countyList": [
            {"key": "ALGARROBO", "value": "Algarrobo"},
            {"key": "ALHUE", "value": "Alhue"},
            {"key": "ALTO DEL CARMEN", "value": "Alto Del Carmen"},
            {"key": "ALTO HOSPICIO", "value": "Alto Hospicio"},
            {"key": "ANCUD", "value": "Ancud"},
            {"key": "ANDACOLLO", "value": "Andacollo"},
            {"key": "ANGOL", "value": "Angol"},
            {"key": "ANTOFAGASTA", "value": "Antofagasta"},
            {"key": "ANTUCO", "value": "Antuco"},
            {"key": "ARAUCO", "value": "Arauco"},
            {"key": "ARICA", "value": "Arica"},
            {"key": "AYSEN", "value": "Aysen"},
            {"key": "BUIN", "value": "Buin"},
            {"key": "BULNES", "value": "Bulnes"},
            {"key": "CABILDO", "value": "Cabildo"},
            {"key": "CABRERO", "value": "Cabrero"},
            {"key": "CALAMA", "value": "Calama"},
            {"key": "CALBUCO", "value": "Calbuco"},
            {"key": "CALDERA", "value": "Caldera"},
            {"key": "CALERA DE TANGO", "value": "Calera De Tango"},
            {"key": "CALLE LARGA", "value": "Calle Larga"},
            {"key": "CAMARONES", "value": "Camarones"},
            {"key": "CAMINA", "value": "Camina"},
            {"key": "CANELA", "value": "Canela"},
            {"key": "CAÑETE", "value": "Cañete"},
            {"key": "CARAHUE", "value": "Carahue"},
            {"key": "CARTAGENA", "value": "Cartagena"},
            {"key": "CASABLANCA", "value": "Casablanca"},
            {"key": "CASTRO", "value": "Castro"},
            {"key": "CATEMU", "value": "Catemu"},
            {"key": "CAUQUENES", "value": "Cauquenes"},
            {"key": "CERRILLOS", "value": "Cerrillos"},
            {"key": "CERRO NAVIA", "value": "Cerro Navia"},
            {"key": "CHAITEN", "value": "Chaiten"},
            {"key": "CHAÑARAL", "value": "Chañaral"},
            {"key": "CHANCO", "value": "Chanco"},
            {"key": "CHEPICA", "value": "Chepica"},
            {"key": "CHIGUAYANTE", "value": "Chiguayante"},
            {"key": "CHILE CHICO", "value": "Chile Chico"},
            {"key": "CHILLAN", "value": "Chillan"},
            {"key": "CHILLAN VIEJO", "value": "Chillan Viejo"},
            {"key": "CHIMBARONGO", "value": "Chimbarongo"},
            {"key": "CHONCHI", "value": "Chonchi"},
            {"key": "CISNES", "value": "Cisnes"},
            {"key": "COBQUECURA", "value": "Cobquecura"},
            {"key": "COCHAMO", "value": "Cochamo"},
            {"key": "COCHRANE", "value": "Cochrane"},
            {"key": "CODEGUA", "value": "Codegua"},
            {"key": "COELEMU", "value": "Coelemu"},
            {"key": "COIHUECO", "value": "Coihueco"},
            {"key": "COINCO", "value": "Coinco"},
            {"key": "COLBUN", "value": "Colbun"},
            {"key": "COLCHANE", "value": "Colchane"},
            {"key": "COLINA", "value": "Colina"},
            {"key": "COLLIPULLI", "value": "Collipulli"},
            {"key": "COLTAUCO", "value": "Coltauco"},
            {"key": "COMBARBALA", "value": "Combarbala"},
            {"key": "CONCEPCION", "value": "Concepcion"},
            {"key": "CONCHALI", "value": "Conchali"},
            {"key": "CONCON", "value": "Concon"},
            {"key": "CONSTITUCION", "value": "Constitucion"},
            {"key": "CONTULMO", "value": "Contulmo"},
            {"key": "COPIAPO", "value": "Copiapo"},
            {"key": "COQUIMBO", "value": "Coquimbo"},
            {"key": "CORONEL", "value": "Coronel"},
            {"key": "CORRAL", "value": "Corral"},
            {"key": "COYHAIQUE", "value": "Coyhaique"},
            {"key": "CUNCO", "value": "Cunco"},
            {"key": "CURACAUTIN", "value": "Curacautin"},
            {"key": "CURACAVI", "value": "Curacavi"},
            {"key": "CURACO DE VELEZ", "value": "Curaco De Velez"},
            {"key": "CURANILAHUE", "value": "Curanilahue"},
            {"key": "CURARREHUE", "value": "Curarrehue"},
            {"key": "CUREPTO", "value": "Curepto"},
            {"key": "CURICO", "value": "Curico"},
            {"key": "DALCAHUE", "value": "Dalcahue"},
            {"key": "DIEGO DE ALMAGRO", "value": "Diego De Almagro"},
            {"key": "DOÑIHUE", "value": "Doñihue"},
            {"key": "EL BOSQUE", "value": "El Bosque"},
            {"key": "EL CARMEN", "value": "El Carmen"},
            {"key": "EL MONTE", "value": "El Monte"},
            {"key": "EL QUISCO", "value": "El Quisco"},
            {"key": "EL TABO", "value": "El Tabo"},
            {"key": "EMPEDRADO", "value": "Empedrado"},
            {"key": "ERCILLA", "value": "Ercilla"},
            {"key": "ESTACION CENTRAL", "value": "Estacion Central"},
            {"key": "FLORIDA", "value": "Florida"},
            {"key": "FREIRE", "value": "Freire"},
            {"key": "FREIRINA", "value": "Freirina"},
            {"key": "FRESIA", "value": "Fresia"},
            {"key": "FRUTILLAR", "value": "Frutillar"},
            {"key": "FUTALEUFU", "value": "Futaleufu"},
            {"key": "FUTRONO", "value": "Futrono"},
            {"key": "GALVARINO", "value": "Galvarino"},
            {"key": "GENERAL LAGOS", "value": "General Lagos"},
            {"key": "GORBEA", "value": "Gorbea"},
            {"key": "GRANEROS", "value": "Graneros"},
            {"key": "GUAITECAS", "value": "Guaitecas"},
            {"key": "HIJUELAS", "value": "Hijuelas"},
            {"key": "HUALAIHUE", "value": "Hualaihue"},
            {"key": "HUALAÑE", "value": "Hualañe"},
            {"key": "HUALQUI", "value": "Hualqui"},
            {"key": "HUARA", "value": "Huara"},
            {"key": "HUASCO", "value": "Huasco"},
            {"key": "HUECHURABA", "value": "Huechuraba"},
            {"key": "ILLAPEL", "value": "Illapel"},
            {"key": "INDEPENDENCIA", "value": "Independencia"},
            {"key": "IQUIQUE", "value": "Iquique"},
            {"key": "ISLA DE MAIPO", "value": "Isla De Maipo"},
            {"key": "ISLA DE PASCUA", "value": "Isla De Pascua"},
            {"key": "JUAN FERNANDEZ", "value": "Juan Fernandez"},
            {"key": "LA CALERA", "value": "La Calera"},
            {"key": "LA CISTERNA", "value": "La Cisterna"},
            {"key": "LA CRUZ", "value": "La Cruz"},
            {"key": "LA ESTRELLA", "value": "La Estrella"},
            {"key": "LA FLORIDA", "value": "La Florida"},
            {"key": "LA GRANJA", "value": "La Granja"},
            {"key": "LA HIGUERA", "value": "La Higuera"},
            {"key": "LA LIGUA", "value": "La Ligua"},
            {"key": "LA PINTANA", "value": "La Pintana"},
            {"key": "LA REINA", "value": "La Reina"},
            {"key": "LA SERENA", "value": "La Serena"},
            {"key": "LA UNION", "value": "La Union"},
            {"key": "LAGO RANCO", "value": "Lago Ranco"},
            {"key": "LAGO VERDE", "value": "Lago Verde"},
            {"key": "LAGUNA BLANCA", "value": "Laguna Blanca"},
            {"key": "LAJA", "value": "Laja"},
            {"key": "LAMPA", "value": "Lampa"},
            {"key": "LANCO", "value": "Lanco"},
            {"key": "LAS CABRAS", "value": "Las Cabras"},
            {"key": "LAS CONDES", "value": "Las Condes"},
            {"key": "LAUTARO", "value": "Lautaro"},
            {"key": "LEBU", "value": "Lebu"},
            {"key": "LICANTEN", "value": "Licanten"},
            {"key": "LIMACHE", "value": "Limache"},
            {"key": "LINARES", "value": "Linares"},
            {"key": "LITUECHE", "value": "Litueche"},
            {"key": "LLANQUIHUE", "value": "Llanquihue"},
            {"key": "LLAY LLAY", "value": "Llay Llay"},
            {"key": "LO BARNECHEA", "value": "Lo Barnechea"},
            {"key": "LO ESPEJO", "value": "Lo Espejo"},
            {"key": "LO PRADO", "value": "Lo Prado"},
            {"key": "LOLOL", "value": "Lolol"},
            {"key": "LONCOCHE", "value": "Loncoche"},
            {"key": "LONGAVI", "value": "Longavi"},
            {"key": "LONQUIMAY", "value": "Lonquimay"},
            {"key": "LOS ALAMOS", "value": "Los Alamos"},
            {"key": "LOS ANDES", "value": "Los Andes"},
            {"key": "LOS ANGELES", "value": "Los Angeles"},
            {"key": "LOS LAGOS", "value": "Los Lagos"},
            {"key": "LOS MUERMOS", "value": "Los Muermos"},
            {"key": "LOS SAUCES", "value": "Los Sauces"},
            {"key": "LOS VILOS", "value": "Los Vilos"},
            {"key": "LOTA", "value": "Lota"},
            {"key": "LUMACO", "value": "Lumaco"},
            {"key": "MACHALI", "value": "Machali"},
            {"key": "MACUL", "value": "Macul"},
            {"key": "MAFIL", "value": "Mafil"},
            {"key": "MAIPU", "value": "Maipu"},
            {"key": "MALLOA", "value": "Malloa"},
            {"key": "MARCHIGUE", "value": "Marchigue"},
            {"key": "MARIA ELENA", "value": "Maria Elena"},
            {"key": "MARIA PINTO", "value": "Maria Pinto"},
            {"key": "MARIQUINA", "value": "Mariquina"},
            {"key": "MAULE", "value": "Maule"},
            {"key": "MAULLIN", "value": "Maullin"},
            {"key": "MEJILLONES", "value": "Mejillones"},
            {"key": "MELIPEUCO", "value": "Melipeuco"},
            {"key": "MELIPILLA", "value": "Melipilla"},
            {"key": "MOLINA", "value": "Molina"},
            {"key": "MONTE PATRIA", "value": "Monte Patria"},
            {"key": "MULCHEN", "value": "Mulchen"},
            {"key": "NACIMIENTO", "value": "Nacimiento"},
            {"key": "NANCAGUA", "value": "Nancagua"},
            {"key": "NAVARINO", "value": "Navarino"},
            {"key": "NAVIDAD", "value": "Navidad"},
            {"key": "NEGRETE", "value": "Negrete"},
            {"key": "NINHUE", "value": "Ninhue"},
            {"key": "NOGALES", "value": "Nogales"},
            {"key": "NUEVA IMPERIAL", "value": "Nueva Imperial"},
            {"key": "ÑUÑOA", "value": "Ñuñoa"},
            {"key": "O’HIGGINS", "value": "O’Higgins"},
            {"key": "OLIVAR", "value": "Olivar"},
            {"key": "OLLAGÜE", "value": "Ollagüe"},
            {"key": "OLMUE", "value": "Olmue"},
            {"key": "OSORNO", "value": "Osorno"},
            {"key": "OVALLE", "value": "Ovalle"},
            {"key": "PADRE HURTADO", "value": "Padre Hurtado"},
            {"key": "PADRE LAS CASAS", "value": "Padre Las Casas"},
            {"key": "PAIHUANO", "value": "Paihuano"},
            {"key": "PAILLACO", "value": "Paillaco"},
            {"key": "PAINE", "value": "Paine"},
            {"key": "PALENA", "value": "Palena"},
            {"key": "PALMILLA", "value": "Palmilla"},
            {"key": "PANGUIPULLI", "value": "Panguipulli"},
            {"key": "PANQUEHUE", "value": "Panquehue"},
            {"key": "PAPUDO", "value": "Papudo"},
            {"key": "PAREDONES", "value": "Paredones"},
            {"key": "PARRAL", "value": "Parral"},
            {"key": "PEDRO AGUIRRE CERDA", "value": "Pedro Aguirre Cerda"},
            {"key": "PELARCO", "value": "Pelarco"},
            {"key": "PELLUHUE", "value": "Pelluhue"},
            {"key": "PEMUCO", "value": "Pemuco"},
            {"key": "PEÑAFLOR", "value": "Peñaflor"},
            {"key": "PEÑALOLEN", "value": "Peñalolen"},
            {"key": "PENCAHUE", "value": "Pencahue"},
            {"key": "PENCO", "value": "Penco"},
            {"key": "PERALILLO", "value": "Peralillo"},
            {"key": "PERQUENCO", "value": "Perquenco"},
            {"key": "PETORCA", "value": "Petorca"},
            {"key": "PEUMO", "value": "Peumo"},
            {"key": "PICA", "value": "Pica"},
            {"key": "PICHIDEGUA", "value": "Pichidegua"},
            {"key": "PICHILEMU", "value": "Pichilemu"},
            {"key": "PINTO", "value": "Pinto"},
            {"key": "PIRQUE", "value": "Pirque"},
            {"key": "PITRUFQUEN", "value": "Pitrufquen"},
            {"key": "PLACILLA", "value": "Placilla"},
            {"key": "PORTEZUELO", "value": "Portezuelo"},
            {"key": "PORVENIR", "value": "Porvenir"},
            {"key": "POZO ALMONTE", "value": "Pozo Almonte"},
            {"key": "PRIMAVERA", "value": "Primavera"},
            {"key": "PROVIDENCIA", "value": "Providencia"},
            {"key": "PUCHUNCAVI", "value": "Puchuncavi"},
            {"key": "PUCON", "value": "Pucon"},
            {"key": "PUDAHUEL", "value": "Pudahuel"},
            {"key": "PUENTE ALTO", "value": "Puente Alto"},
            {"key": "PUERTO MONTT", "value": "Puerto Montt"},
            {"key": "PUERTO NATALES", "value": "Puerto Natales"},
            {"key": "PUERTO OCTAY", "value": "Puerto Octay"},
            {"key": "PUERTO SAAVEDRA", "value": "Puerto Saavedra"},
            {"key": "PUERTO VARAS", "value": "Puerto Varas"},
            {"key": "PUMANQUE", "value": "Pumanque"},
            {"key": "PUNITAQUI", "value": "Punitaqui"},
            {"key": "PUNTA ARENAS", "value": "Punta Arenas"},
            {"key": "PUQUELDON", "value": "Puqueldon"},
            {"key": "PUREN", "value": "Puren"},
            {"key": "PURRANQUE", "value": "Purranque"},
            {"key": "PUTAENDO", "value": "Putaendo"},
            {"key": "PUTRE", "value": "Putre"},
            {"key": "PUYEHUE", "value": "Puyehue"},
            {"key": "QUEILEN", "value": "Queilen"},
            {"key": "QUELLON", "value": "Quellon"},
            {"key": "QUEMCHI", "value": "Quemchi"},
            {"key": "QUILACO", "value": "Quilaco"},
            {"key": "QUILICURA", "value": "Quilicura"},
            {"key": "QUILLECO", "value": "Quilleco"},
            {"key": "QUILLON", "value": "Quillon"},
            {"key": "QUILLOTA", "value": "Quillota"},
            {"key": "QUILPUE", "value": "Quilpue"},
            {"key": "QUINCHAO", "value": "Quinchao"},
            {"key": "QUINTA DE TILCOCO", "value": "Quinta De Tilcoco"},
            {"key": "QUINTA NORMAL", "value": "Quinta Normal"},
            {"key": "QUINTERO", "value": "Quintero"},
            {"key": "QUIRIHUE", "value": "Quirihue"},
            {"key": "RANCAGUA", "value": "Rancagua"},
            {"key": "RANQUIL", "value": "Ranquil"},
            {"key": "RAUCO", "value": "Rauco"},
            {"key": "RECOLETA", "value": "Recoleta"},
            {"key": "RENAICO", "value": "Renaico"},
            {"key": "RENCA", "value": "Renca"},
            {"key": "RENGO", "value": "Rengo"},
            {"key": "REQUINOA", "value": "Requinoa"},
            {"key": "RETIRO", "value": "Retiro"},
            {"key": "RINCONADA", "value": "Rinconada"},
            {"key": "RIO BUENO", "value": "Rio Bueno"},
            {"key": "RIO CLARO", "value": "Rio Claro"},
            {"key": "RIO HURTADO", "value": "Rio Hurtado"},
            {"key": "RIO IBAÑEZ", "value": "Rio Ibañez"},
            {"key": "RIO NEGRO", "value": "Rio Negro"},
            {"key": "RIO VERDE", "value": "Rio Verde"},
            {"key": "ROMERAL", "value": "Romeral"},
            {"key": "SAGRADA FAMILIA", "value": "Sagrada Familia"},
            {"key": "SALAMANCA", "value": "Salamanca"},
            {"key": "SAN ANTONIO", "value": "San Antonio"},
            {"key": "SAN BERNARDO", "value": "San Bernardo"},
            {"key": "SAN CARLOS", "value": "San Carlos"},
            {"key": "SAN CLEMENTE", "value": "San Clemente"},
            {"key": "SAN ESTEBAN", "value": "San Esteban"},
            {"key": "SAN FABIAN", "value": "San Fabian"},
            {"key": "SAN FELIPE", "value": "San Felipe"},
            {"key": "SAN FERNANDO", "value": "San Fernando"},
            {"key": "SAN FRANCISCO DE MOSTAZAL", "value": "San Francisco De Mostazal"},
            {"key": "SAN GREGORIO", "value": "San Gregorio"},
            {"key": "SAN GREGORIO DE ÑIQUEN", "value": "San Gregorio De Ñiquen"},
            {"key": "SAN IGNACIO", "value": "San Ignacio"},
            {"key": "SAN JAVIER", "value": "San Javier"},
            {"key": "SAN JOAQUIN", "value": "San Joaquin"},
            {"key": "SAN JOSE MAIPO", "value": "San Jose Maipo"},
            {"key": "SAN JUAN DE LA COSTA", "value": "San Juan De La Costa"},
            {"key": "SAN MIGUEL", "value": "San Miguel"},
            {"key": "SAN NICOLAS", "value": "San Nicolas"},
            {"key": "SAN PABLO", "value": "San Pablo"},
            {"key": "SAN PEDRO", "value": "San Pedro"},
            {"key": "SAN PEDRO DE ATACAMA", "value": "San Pedro De Atacama"},
            {"key": "SAN PEDRO DE LA PAZ", "value": "San Pedro De La Paz"},
            {"key": "SAN RAFAEL", "value": "San Rafael"},
            {"key": "SAN RAMON", "value": "San Ramon"},
            {"key": "SAN ROSENDO", "value": "San Rosendo"},
            {"key": "SAN VICENTE", "value": "San Vicente"},
            {"key": "SANTA BARBARA", "value": "Santa Barbara"},
            {"key": "SANTA CRUZ", "value": "Santa Cruz"},
            {"key": "SANTA JUANA", "value": "Santa Juana"},
            {"key": "SANTA MARIA", "value": "Santa Maria"},
            {"key": "SANTIAGO", "value": "Santiago"},
            {"key": "SANTIAGO CENTRO", "value": "Santiago Centro"},
            {"key": "SANTIAGO OESTE", "value": "Santiago Oeste"},
            {"key": "SANTIAGO SUR", "value": "Santiago Sur"},
            {"key": "SANTO DOMINGO", "value": "Santo Domingo"},
            {"key": "SIERRA GORDA", "value": "Sierra Gorda"},
            {"key": "TALAGANTE", "value": "Talagante"},
            {"key": "TALCA", "value": "Talca"},
            {"key": "TALCAHUANO", "value": "Talcahuano"},
            {"key": "TALTAL", "value": "Taltal"},
            {"key": "TEMUCO", "value": "Temuco"},
            {"key": "TENO", "value": "Teno"},
            {"key": "TEODORO SCHMIDT", "value": "Teodoro Schmidt"},
            {"key": "TIERRA AMARILLA", "value": "Tierra Amarilla"},
            {"key": "TIL-TIL", "value": "Til-Til"},
            {"key": "TIMAUKEL", "value": "Timaukel"},
            {"key": "TIRUA", "value": "Tirua"},
            {"key": "TOCOPILLA", "value": "Tocopilla"},
            {"key": "TOLTEN", "value": "Tolten"},
            {"key": "TOME", "value": "Tome"},
            {"key": "TORRES DEL PAINE", "value": "Torres Del Paine"},
            {"key": "TORTEL", "value": "Tortel"},
            {"key": "TRAIGUEN", "value": "Traiguen"},
            {"key": "TREHUACO", "value": "Trehuaco"},
            {"key": "TUCAPEL", "value": "Tucapel"},
            {"key": "VALDIVIA", "value": "Valdivia"},
            {"key": "VALLENAR", "value": "Vallenar"},
            {"key": "VALPARAISO", "value": "Valparaiso"},
            {"key": "VICHUQUEN", "value": "Vichuquen"},
            {"key": "VICTORIA", "value": "Victoria"},
            {"key": "VICUÑA", "value": "Vicuña"},
            {"key": "VILCUN", "value": "Vilcun"},
            {"key": "VILLA ALEGRE", "value": "Villa Alegre"},
            {"key": "VILLA ALEMANA", "value": "Villa Alemana"},
            {"key": "VILLARRICA", "value": "Villarrica"},
            {"key": "VIÑA DEL MAR", "value": "Viña Del Mar"},
            {"key": "VITACURA", "value": "Vitacura"},
            {"key": "YERBAS BUENAS", "value": "Yerbas Buenas"},
            {"key": "YUMBEL", "value": "Yumbel"},
            {"key": "YUNGAY", "value": "Yungay"},
            {"key": "ZAPALLAR", "value": "Zapallar"}
        ]
    },
    "GB": {
        "countyList": [
            {"key": "ABRDN", "value": "Aberdeenshire"},
            {"key": "ANGUS", "value": "Angus"},
            {"key": "ARGYL", "value": "Argyll"},
            {"key": "AVON", "value": "Avon"},
            {"key": "AYR", "value": "Ayrshire"},
            {"key": "BANFF", "value": "Banffshire"},
            {"key": "BDFRD", "value": "Bedfordshire"},
            {"key": "BERKS", "value": "Berkshire"},
            {"key": "BRWCK", "value": "Berwickshire"},
            {"key": "BCKHM", "value": "Buckinghamshire"},
            {"key": "CTHNS", "value": "Caithness"},
            {"key": "CMBRG", "value": "Cambridgeshire"},
            {"key": "CHNLS", "value": "Channel Isles"},
            {"key": "CHESH", "value": "Cheshire"},
            {"key": "CLKMN", "value": "Clackmannanshire"},
            {"key": "CLVND", "value": "Cleveland"},
            {"key": "CLWYD", "value": "Clwyd"},
            {"key": "CRNWL", "value": "Cornwall"},
            {"key": "ANTRM", "value": "County Antrim"},
            {"key": "ARMGH", "value": "County Armagh"},
            {"key": "DOWN", "value": "County Down"},
            {"key": "DURHM", "value": "County Durham"},
            {"key": "FRMNG", "value": "County Fermanagh"},
            {"key": "LNDRY", "value": "County Londonderry"},
            {"key": "TYRON", "value": "County Tyrone"},
            {"key": "CMBRA", "value": "Cumbria"},
            {"key": "DERBY", "value": "Derbyshire"},
            {"key": "DEVON", "value": "Devon"},
            {"key": "DORST", "value": "Dorset"},
            {"key": "DMFRS", "value": "Dumfriesshire"},
            {"key": "DNBRT", "value": "Dunbartonshire"},
            {"key": "DYFED", "value": "Dyfed"},
            {"key": "ELOTH", "value": "East Lothian"},
            {"key": "ESUSX", "value": "East Sussex"},
            {"key": "ENG", "value": "England"},
            {"key": "ESSEX", "value": "Essex"},
            {"key": "FIFE", "value": "Fife"},
            {"key": "FLNT", "value": "Flintshire"},
            {"key": "GLOCS", "value": "Gloucestershire"},
            {"key": "GWENT", "value": "Gwent"},
            {"key": "GWYND", "value": "Gwynedd"},
            {"key": "HAMPS", "value": "Hampshire"},
            {"key": "HRFRD", "value": "Herefordshire"},
            {"key": "HRTFD", "value": "Hertfordshire"},
            {"key": "INVRN", "value": "Inverness-Shire"},
            {"key": "ARRAN", "value": "Isle Of Arran"},
            {"key": "BARRA", "value": "Isle Of Barra"},
            {"key": "BNBCL", "value": "Isle Of Benbecula"},
            {"key": "BUTE", "value": "Isle Of Bute"},
            {"key": "CANNA", "value": "Isle Of Canna"},
            {"key": "COLL", "value": "Isle Of Coll"},
            {"key": "CLNSY", "value": "Isle Of Colonsay"},
            {"key": "CMBRE", "value": "Isle Of Cumbrae"},
            {"key": "EIGG", "value": "Isle Of Eigg"},
            {"key": "GIGHA", "value": "Isle Of Gigha"},
            {"key": "HARIS", "value": "Isle Of Harris"},
            {"key": "IONA", "value": "Isle Of Iona"},
            {"key": "ISLAY", "value": "Isle Of Islay"},
            {"key": "JURA", "value": "Isle Of Jura"},
            {"key": "LEWIS", "value": "Isle Of Lewis"},
            {"key": "MAN", "value": "Isle Of Man"},
            {"key": "MULL", "value": "Isle Of Mull"},
            {"key": "NUIST", "value": "Isle Of North Uist"},
            {"key": "RHUM", "value": "Isle Of Rhum"},
            {"key": "SCLPY", "value": "Isle Of Scalpay"},
            {"key": "SKYE", "value": "Isle Of Skye"},
            {"key": "SUIST", "value": "Isle Of South Uist"},
            {"key": "TIREE", "value": "Isle Of Tiree"},
            {"key": "WIGHT", "value": "Isle Of Wight"},
            {"key": "SCILY", "value": "Isles Of Scilly"},
            {"key": "KENT", "value": "Kent"},
            {"key": "KNCRD", "value": "Kincardineshire"},
            {"key": "KINRS", "value": "Kinross-shire"},
            {"key": "KRKCB", "value": "Kirkcudbrightshire"},
            {"key": "LANRK", "value": "Lanarkshire"},
            {"key": "LANCS", "value": "Lancashire"},
            {"key": "LESTR", "value": "Leicestershire"},
            {"key": "LINCN", "value": "Lincolnshire"},
            {"key": "LON", "value": "London"},
            {"key": "MRSYD", "value": "Merseyside"},
            {"key": "MGMRG", "value": "Mid Glamorgan"},
            {"key": "MDLSX", "value": "Middlesex"},
            {"key": "MLOTH", "value": "Midlothian"},
            {"key": "MORAY", "value": "Morayshire"},
            {"key": "NAIRN", "value": "Nairnshire"},
            {"key": "NRFLK", "value": "Norfolk"},
            {"key": "NHMBR", "value": "North Humberside"},
            {"key": "NYORK", "value": "North Yorkshire"},
            {"key": "NHAMP", "value": "Northamptonshire"},
            {"key": "NIR", "value": "Northern Ireland"},
            {"key": "NUMBL", "value": "Northumberland"},
            {"key": "NOTHM", "value": "Nottinghamshire"},
            {"key": "ORKNY", "value": "Orkney"},
            {"key": "OXFRD", "value": "Oxfordshire"},
            {"key": "PEBLS", "value": "Peeblesshire"},
            {"key": "PERTH", "value": "Perthshire"},
            {"key": "POWYS", "value": "Powys"},
            {"key": "RNFRW", "value": "Renfrewshire"},
            {"key": "ROSS", "value": "Ross-shire"},
            {"key": "RXBRG", "value": "Roxburghshire"},
            {"key": "SCT", "value": "Scotland"},
            {"key": "SLKRK", "value": "Selkirkshire"},
            {"key": "SHETL", "value": "Shetland Islands"},
            {"key": "SHROP", "value": "Shropshire"},
            {"key": "SMRST", "value": "Somerset"},
            {"key": "SGMRG", "value": "South Glamorgan"},
            {"key": "SHMBR", "value": "South Humberside"},
            {"key": "SYORK", "value": "South Yorkshire"},
            {"key": "STFRD", "value": "Staffordshire"},
            {"key": "STRLG", "value": "Stirlingshire"},
            {"key": "SUFLK", "value": "Suffolk"},
            {"key": "SURRY", "value": "Surrey"},
            {"key": "STHLN", "value": "Sutherland"},
            {"key": "TYNE", "value": "Tyne And Wear"},
            {"key": "WAL", "value": "Wales"},
            {"key": "WRWCK", "value": "Warwickshire"},
            {"key": "WGLMG", "value": "West Glamorgan"},
            {"key": "WLOTH", "value": "West Lothian"},
            {"key": "WMIDL", "value": "West Midlands"},
            {"key": "WSUSX", "value": "West Sussex"},
            {"key": "WYORK", "value": "West Yorkshire"},
            {"key": "WIGTN", "value": "Wigtownshire"},
            {"key": "WILTS", "value": "Wiltshire"},
            {"key": "WRCST", "value": "Worcestershire"}
        ]
    }
}
